import { request } from 'src/common/rest/index';
import appendQueryParams from 'src/common/utils/append-query-params';

let baseUrl = '';
export const setBaseUrl = value => {
  baseUrl = value;
};

export const validate = (data, locale = 'en-US') => {
  const url = appendQueryParams(
    {
      user_locale: locale,
    },
    `${baseUrl}/website/v2/validation`,
  );

  return request.post(url, JSON.stringify(data), {
    headers: {
      'content-type': 'application/json',
    },
  });
};



// WEBPACK FOOTER //
// ./src/client/js/facades/eagle/validation.js